__webpack_require__.p = "/portfolioReact/";